import { defineNuxtRouteMiddleware, navigateTo } from 'nuxt/app'
import { useRegistrationStore } from '~/stores/registration'

export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server) {
    const registrationStore = useRegistrationStore()

    if (to.name === 'registreren-thuiskok-check') {
      if (!registrationStore.formProgress.cook.isConfirmStep) {
        return navigateTo({
          name: 'registreren-thuiskok'
        })
      } else if (registrationStore.formProgress.cook.hasSubmitted) {
        return navigateTo({
          name: 'registreren-bedankt-thuiskok-municipality',
          params: {
            municipality: registrationStore.formProgress.cook.municipality ?? 'onbekend'
          }
        })
      }
    }

    if (
      to.name === 'registreren-thuiskok' &&
      registrationStore.formProgress.cook.hasSubmitted
    ) {
      return navigateTo({
        name: 'registreren-bedankt-thuiskok-municipality',
        params: {
          municipality: registrationStore.formProgress.cook.municipality ?? 'onbekend'
        }
      })
    }

    if (
      to.name === 'registreren-bedankt-thuiskok-municipality' &&
      !registrationStore.formProgress.cook.hasSubmitted
    ) {
      if (registrationStore.formProgress.cook.isConfirmStep) {
        return navigateTo({
          name: 'registreren-thuiskok-check'
        })
      } else {
        return navigateTo({
          name: 'registreren-thuiskok'
        })
      }
    }
  } else if (import.meta.client) {
    const registrationStore = useRegistrationStore()

    if (to.name === 'registreren-thuiskok-check') {
      if (!registrationStore.cook.personalDetailsStep.gender) {
        return navigateTo({
          name: 'registreren-thuiskok'
        })
      }
    }
  }
})
